import { DSFlex, DSIcon, DSText } from '@zoe/ds-web'
import React from 'react'
import type { ResponsiveImageType } from 'react-datocms'

import type { FragmentComponent } from '@/types/graphql'

import { DatoImage } from '@/components/elements/global/DatoImage'

type InlineAvatarProps = {
  image?: {
    responsiveImage: ResponsiveImageType
  }
  label: string
  verifiedBadgeLabel?: string
}

export type InlineAvatarRecord = {
  __typename: 'InlineAvatarRecord'
  id: string
  label: string
  verifiedBadgeLabel?: string
  image?: {
    responsiveImage: ResponsiveImageType
  }
}

const fragment = `
  fragment InlineAvatarBlockFragment on InlineAvatarRecord {
    __typename
    id
    label
    verifiedBadgeLabel
    image {
      responsiveImage {
        alt
        aspectRatio
        base64
        bgColor
        height
        sizes
        src
        srcSet
        title
        webpSrcSet
        width
      }
    }
  }
`

export const InlineAvatar: React.FC<InlineAvatarProps> = ({ image, label, verifiedBadgeLabel }) => {
  return (
    <DSFlex direction="row" alignItems="center" justifyContent="space-between" gap={8}>
      <DSFlex direction="row" alignItems="center" gap={8}>
        {image && (
          <div style={{ width: '42px', height: '42px', borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
            <DatoImage data={image.responsiveImage} />
          </div>
        )}
        <DSText as="span" variant="fluid-paragraph-200" weight="semiBold">
          {label}
        </DSText>
      </DSFlex>
      {verifiedBadgeLabel && (
        <DSFlex direction="row" alignItems="center" gap={8}>
          <DSIcon name="tick-in-star" color="brand" size={24} ariaHidden />
          <DSText as="span" variant="fluid-paragraph-200">
            {verifiedBadgeLabel}
          </DSText>
        </DSFlex>
      )}
    </DSFlex>
  )
}

export const InlineAvatarBlock: FragmentComponent<{}, InlineAvatarRecord> = ({ record }) => {
  return <InlineAvatar image={record.image} label={record.label} verifiedBadgeLabel={record.verifiedBadgeLabel} />
}

InlineAvatarBlock.fragment = fragment
InlineAvatarBlock.recordName = 'InlineAvatarRecord'
